import Vue from 'vue'
import VueRouter from 'vue-router'
var VueScrollTo = require('vue-scrollto');

Vue.use(VueRouter)


const routes = [
  // Стартовая страница
  {
    path: '/',
    name: 'Start',
    meta: { layout: 'startBlockLayout', auth:false },
    component: () => import('../views/Start.vue')
  },
  // Страница регистрации пользователя
  {
    path: '/register',
    name: 'registration',
    meta: { layout: 'startBlockLayout', auth:false },
    component: () => import('../views/Registration.vue')
  },
  // Главная
  {
    path: '/mainPage',
    name: 'mainPage',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true }, //Показать header на странице
    component: () => import('../views/Main.vue')
  },
  // Личный кабинет пользователя
  {
    path: '/userPage',
    name: 'userPage',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    component: () => import('../views/UserPage.vue')
  },
  // Страница актуальных коллекций
  {
    path: '/collections',
    name: 'collections',
    props: true,
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    component: () => import('../views/Collections.vue'),
  },
  // Страница регистрации презентации
  {
    path: '/Presentation-registr',
    name: 'PresentationRegistr',
    meta: { header: 'Header', layout: 'mainLayout', auth:true },
    component: () => import('../views/PresentationRegistration.vue'),
    props: true
  },
  // Страница цели/планы при регистрации презентации
  {
    path: '/plan/:collectionID',
    name: 'plan',
    meta: { header: 'Header', layout: 'mainLayout', auth:true },
    component: () => import('../views/Plan'),
    props: true
  },

  {
    path: '/clients',
    name: 'clients',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    component: () => import('../views/Clients.vue'),
  },
  // Страница запланированных презентаций
  {
    path: '/presentationList',
    name: 'presentationList',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    component: () => import('../views/PresentationList.vue'),
  },
  //Страница история презентаций
  {
    path: '/history',
    name: 'history',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    component: () => import('../views/History.vue'), 
  },
  // Страница каталога коллекции(шахматы)
  {
    path: '/catalog/:id',
    name: 'catalog',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true }, //Показать header на странице
    component: () => import('../views/Catalog.vue'),
    props: true,
    // beforeEnter: (to, from, next) => {

    //   if (localStorage.getItem('userID') == null) { //Если в localStorage нет поля UserID, переход на главную
    //     next({ path: '/' })
    //   }
    //   else {
    //     next()
    //   }
    // }
  },
  // Страница карточка товара
  {
    path: '/catalog/:collection/:element',
    name: 'productCard',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    component: () => import('../views/ProductCard.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      // При переходу в карточку товара страница скроллится наверх
      document.getElementById('app').scrollIntoView();
      next()
    }
  },
  //Страница корзины
  {
    path: '/order',
    name: 'cart',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    component: () => import('../views/OrderPage.vue'),
  },
   //Страница цели/планы после презентации
  {
    path: '/targets-page',
    name: 'targetsPage',
    meta: { layout: 'startBlockLayout', auth:true },
    props: true,
    component: () => import('../views/Targets.vue'),
  },
  
  //Страница комментарий к заказу
  {
    path: '/comment',
    name: 'comment',
    meta: { layout: 'startBlockLayout', auth:true },
    props: true,
    component: () => import('../views/Comment.vue'),
  },

  // Страница "работа по замене - регистрация клиента"
  {
    path: '/replacement-registration',
    name: 'replacement-registration',
    meta: { header: 'Header', layout: 'mainLayout', auth:true },
    props: true,
    component: () => import('../views/ReplacementRegister.vue'),
  },

  // Страница "работа по замене - главная"
  {
    path: '/replacement/:id',
    name: 'replacement',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    props: true,
    component: () => import('../views/ReplacementMain.vue'),
  },

  //Карточка клиента
  {
    path: '/clientCard/:id',
    name: 'clientCard',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    props: true,
    component: () => import('../views/ClientCard.vue'),
  },

  //Редактирование запланированной презентации
  {
    path: '/editPresentation/:id',
    name: 'editPresentation',
    meta: { header: 'Header', layout: 'mainLayout', auth:true },
    props: true,
    component: () => import('../views/PresentationEdit.vue'),
  },
  // Контроль отстройки: регистрация
  {
    path: '/control-registration',
    name: 'contolRegistration',
    meta: { header: 'Header', layout: 'mainLayout', auth:true },
    props: true,
    component: () => import('../views/ContolRegistration.vue'),
  },
  // Контроль отстройки: каталог товаров
  {
    path: '/control-catalog/',
    name: 'contolCatalog',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    props: true,
    component: () => import('../views/ContolCatalog.vue'),
  },
  // Контроль отстройки: детальная карточка
  {
    path: '/control-detail/:collection/:element',
    name: 'controlDetail',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    component: () => import('../views/ControlDetail.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      // При переходу в карточку товара страница скроллится наверх
      document.getElementById('app').scrollIntoView();
      next()
    }
  },
  //Страница заказать товар: регистрация
  {
    path: '/shop-registration',
    name: 'shopRegister',
    meta: { header: 'Header', layout: 'mainLayout', auth:true },
    props: true,
    component: () => import('../views/ShopRegister.vue'),
  },
  //Страница заказать товар: категории +
  {
    path: '/shop-pre-catatlog/',
    name: 'shopPreCatalog',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    props: true,
    component: () => import('../views/ShopPreCatalog.vue'),
  },
     
  //Страница заказать товар: каталог
  {
    path: '/shop/:shopName',
    name: 'shopCatalog',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    props: true,
    component: () => import('../views/ShopCatalog.vue'),
  },

  //Страница заказать товар: каталог подраздел
  {
    path: '/shop/:shopName/:id/',
    name: 'shopCatalog-child',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    props: true,
    component: () => import('../views/ShopCatalog.vue'),
  },

  //Страница заказать товар: каталог шахматы
  {
    path: '/shop/chess/:shopName/:id',
    name: 'catalog-shop',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    props: true,
    component: () => import('../views/shopChessCatalog.vue'),
  },

  // Страница заказать товар: карточка товара
  {
    path: '/shop/:shopName/:collection/:element',
    name: 'shop-product-card',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    component: () => import('../views/shopProductCard.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      // При переходу в карточку товара страница скроллится наверх
      document.getElementById('app').scrollIntoView();
      next()
    }
  },

  //Страница заказать товар: корзина
  {
    path: '/:shopName/shop-cart',
    name: 'shopCart',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    component: () => import('../views/ShopCart.vue'),
  },

  //Контроль отстройки: корзина
  {
    path: '/manufacture-order',
    name: 'manufactureOrder',
    meta: { header: 'Header', layout: 'bgWhiteLayout', auth:true },
    component: () => import('../views/ManufactureOrder.vue'),
  },
 
  //Контроль отстройки: комментарий
  {
    path: '/manufacture-comment/:id',
    name: 'manufactureComment',
    meta: {layout: 'startBlockLayout', auth:true },
    component: () => import('../views/ControlComment.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const currentUser = localStorage.getItem('userID')
  const requireAuth = to.matched.some(record => record.meta.auth)

  if(requireAuth && !currentUser){
    next('/')
  } else {
    next()
  }

})

export default router
